import React from "react";
import ReactDOM from "react-dom";
import injectTapEventPlugin from "react-tap-event-plugin";

import { getFontsForPdf } from "@common/pdf/documentTemplate";
import AppContent from "./App";

// Import assets
import "bootstrap/dist/css/bootstrap.min.css";
import "@public/assets/fonts/567373/1B4E86DA7DBDFD2B8.css";
import "draft-js/dist/Draft.css";

getFontsForPdf();

// Needed for onTouchTap (http://stackoverflow.com/a/34015469/988941)
injectTapEventPlugin();

// Render the App component in the DOM
ReactDOM.render(<AppContent />, document.getElementById("root"));

// Enable hot reloading with the 'create-react-app' template
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js